import { supabase } from "./supabase/auth";

export type ActivityAction =
  | "login_success"
  | "login_failed"
  | "signup"
  | "page_view"
  | "sign_out"
  | "formula_save"
  | "formula_save_as"
  | "formula_delete"
  | "ingredient_create"
  | "ingredient_update";

export async function logActivity(
  action: ActivityAction,
  metadata?: Record<string, unknown>
) {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    const email =
      session?.user?.email ||
      (metadata?.email as string) ||
      "unknown";

    await supabase.from("activity_log").insert({
      user_id: session?.user?.id || null,
      email,
      action,
      metadata: metadata || null,
    });
  } catch {
    // Silently fail — logging should never block the UI
  }
}
